var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / UZ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-UZ",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#04AAC8",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#23C840",
    mask: "url(#mask-2)",
    x: 0,
    y: 13.3333333,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66666667,1.33333333 C5.07801751,1.33333333 5.4603633,1.45751874 5.77825807,1.67044361 C5.74173511,1.66791708 5.70434691,1.66666667 5.66666667,1.66666667 C4.74619208,1.66666667 4,2.41285875 4,3.33333333 C4,4.25380792 4.74619208,5 5.66666667,5 L5.77825807,4.99622306 C5.4603633,5.20914792 5.07801751,5.33333333 4.66666667,5.33333333 C3.56209717,5.33333333 2.66666667,4.43790283 2.66666667,3.33333333 C2.66666667,2.22876383 3.56209717,1.33333333 4.66666667,1.33333333 Z M7.33333333,4 C7.70152317,4 8,4.29847683 8,4.66666667 C8,5.0348565 7.70152317,5.33333333 7.33333333,5.33333333 C6.9651435,5.33333333 6.66666667,5.0348565 6.66666667,4.66666667 C6.66666667,4.29847683 6.9651435,4 7.33333333,4 Z M12.6666667,4 C13.0348565,4 13.3333333,4.29847683 13.3333333,4.66666667 C13.3333333,5.0348565 13.0348565,5.33333333 12.6666667,5.33333333 C12.2984768,5.33333333 12,5.0348565 12,4.66666667 C12,4.29847683 12.2984768,4 12.6666667,4 Z M10,4 C10.3681898,4 10.6666667,4.29847683 10.6666667,4.66666667 C10.6666667,5.0348565 10.3681898,5.33333333 10,5.33333333 C9.63181017,5.33333333 9.33333333,5.0348565 9.33333333,4.66666667 C9.33333333,4.29847683 9.63181017,4 10,4 Z M10,1.33333333 C10.3681898,1.33333333 10.6666667,1.63181017 10.6666667,2 C10.6666667,2.36818983 10.3681898,2.66666667 10,2.66666667 C9.63181017,2.66666667 9.33333333,2.36818983 9.33333333,2 C9.33333333,1.63181017 9.63181017,1.33333333 10,1.33333333 Z M12.6666667,1.33333333 C13.0348565,1.33333333 13.3333333,1.63181017 13.3333333,2 C13.3333333,2.36818983 13.0348565,2.66666667 12.6666667,2.66666667 C12.2984768,2.66666667 12,2.36818983 12,2 C12,1.63181017 12.2984768,1.33333333 12.6666667,1.33333333 Z",
    id: "Oval-68",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUz);
export default __webpack_public_path__ + "static/media/UZ.2dc6491ba59602bd83b1404a5cb01ef6.svg";
export { ForwardRef as ReactComponent };